import de_DE from './de_DE.json';
import en_US from './en_US.json';

export default {
  en_US,
  de_DE,
};
